import * as React from 'react';
import { DropdownMenu, SortOrder } from 'ui';
import * as navigate from 'app/area/shared/navigation';
import { DomainNode } from 'ui/sort-order/types';
import { MdArrowDropDown, MdArrowRight } from 'react-icons/md';
import { DefaultSortOrder, SharedState } from 'app/types-shared';
import { FavouriteContextMenu } from './favourite-context-menu';

import styles from './display-options.scss';
import { FavouriteReportDownload } from 'app/area/favourite/types';
import { reportTypes } from 'app/area/favourite/constants';
import { dropdownRefContextMenu } from 'app/components/helpers';

export interface DisplayOptionsLinkProps {
  value: number;
  isActive: boolean;
  description: string;
}

class DisplayOptionsLink extends React.Component<DisplayOptionsLinkProps, {}> {

  private onClick = (e: React.SyntheticEvent<any>) => {
    e.preventDefault();
    navigate.toSearch({ report: this.props.value.toString(10) });
  };

  public render() {
    return (
      <button
        type="button"
        onClick={this.onClick}
        className={`dropdown-item ${this.props.isActive && 'active'}`}
        data-testid={`report-option-${this.props.value}`}
      >
        {this.props.description}
      </button>
    );
  }
}

export interface DisplayOptionsProps {
  sortOptions?: DomainNode[];
  reportCategory?: any;
  report: number;
  favouriteId: number;
  translation: any;
  sharedState: SharedState;
  loadSortOptions: (query?: string) => void;
  updateSortOptions: (sortOrderFields: DefaultSortOrder[]) => void;
  fetchingSortOptions: boolean;
  createReport: () => void;
  showUpdate: boolean;
  updateReport: () => void;
  displayExportToZip: () => void;
  downloadReport: (data: FavouriteReportDownload) => void;
  getMulitpleSuppliersUrl: () => void;
  urlMultipleSuppliers: string;
  sortOrderFields?: DefaultSortOrder[];
}

export const DisplayOptions = (props: DisplayOptionsProps) => {

  const { report, reportCategory, sortOrderFields } = props;
  const [otherReportsExpanded, setOtherReportsExpanded] = React.useState(false);
  const otherReportsMenuId = React.useId();

  const toggleOtherReports = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOtherReportsExpanded(expanded => !expanded);
  };

  const closeOtherReports = () => setOtherReportsExpanded(false);

  const selectedOption = reportCategory.find(r => r.value === report);
  const toggle = <div>
    <span>{selectedOption && selectedOption.description}</span>
    <MdArrowDropDown className="dropdown-arrow" />
  </div>;

  const onDone = (sortOder: DefaultSortOrder[]) => {
    props.updateSortOptions(sortOder);
  };
  
  const hideSortOrder = report === reportTypes.frequencyReport || 
                        report === reportTypes.selectionReport ||
                        report === reportTypes.riskReport;
  
  const otherReports = props.reportCategory.filter(c => c.displayInFolder);
  return <div className={styles.main} data-testid="display-options">
    {!hideSortOrder && (<div className={styles.sortOrder} data-testid="sort-order-section">
      <SortOrder
        componentId={'1'}
        translation={props.translation}
        options={props.sortOptions}
        loadOptions={props.loadSortOptions}
        onDone={onDone}
        fetching={props.fetchingSortOptions}
        sortOrderFields={sortOrderFields} />
    </div>)}
    <div
      className={`${styles.viewAs} ${otherReportsExpanded ? styles.otherReportsExpanded : ''}`}
      data-testid="view-as-section"
    >
      <span className={styles.outerLabel}>{props.translation.view_as}</span>
      <DropdownMenu dropdownNode={toggle} closeAfterClick onCloseMenu={closeOtherReports} data-testid="report-dropdown">
        {props.reportCategory
          .filter(c => !c.displayInFolder)
          .map(c => (
            <DisplayOptionsLink
              key={c.value}
              value={c.value}
              isActive={c.value === report}
              description={c.description}
            />
          ))}

        {!!otherReports?.length && (
          <li className={`${styles.nestedDropdown} ${otherReportsExpanded ? styles.expanded : ''}`}>
            <button
              type="button"
              className={`dropdown-item ${styles.submenuToggle}`}
              onClick={toggleOtherReports}
              aria-expanded={otherReportsExpanded}
              aria-controls={otherReportsMenuId}
            >
              <span>{props.translation.other_case_reports}</span>
              <MdArrowRight className={styles.submenuArrow} />
            </button>

            <ul
              id={otherReportsMenuId}
              className={`dropdown-menu ${styles.subMenu}`}
              ref={dropdownRefContextMenu}
            >
              {otherReports.map(c => (
                <DisplayOptionsLink
                  key={c.value}
                  value={c.value}
                  isActive={c.value === report}
                  description={c.description}
                />
              ))}
            </ul>
          </li>
        )}

      </DropdownMenu>
    </div>
    <FavouriteContextMenu
      {...props} 
    />
  </div>;
};
